/**
 * Lightweight className joiner. Filters falsy values; last duplicate wins
 * for most Tailwind purposes because `className` strings are concatenated
 * left to right and the browser resolves later-declared utilities last.
 *
 * We intentionally avoid pulling in `clsx` + `tailwind-merge` here to keep
 * the consent bundle tiny — the consumers of this helper control the
 * className inputs, so conflicting utility classes are the author's
 * responsibility, not a runtime merge concern.
 */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ")
}
